import { LeadMinimalDTO } from "../types";
import PreferredContactMethodIds from "./PreferredContactMethodIds";

export default class Formatters {

    static format_lead_preferred_contact_method(lead: LeadMinimalDTO) {
        switch (lead.preferredContactMethodId) {
            case PreferredContactMethodIds.PHONE:
                return Formatters.format_phone_number(lead.phone);
            case PreferredContactMethodIds.CELLPHONE:
                return Formatters.format_phone_number(lead.cellphone);
            case PreferredContactMethodIds.EMAIL:
                return lead.email;
            default:
                return '';
        }
    }

    static lead_preferred_contact_method_name(lead: LeadMinimalDTO) {
        switch (lead.preferredContactMethodId) {
            case PreferredContactMethodIds.PHONE:
                return 'Phone';
            case PreferredContactMethodIds.CELLPHONE:
                return 'Cellphone';
            case PreferredContactMethodIds.EMAIL:
                return 'Email';
            default:
                return '';
        }
    }

    static format_phone_number(phone_number: any) {
        if ((typeof phone_number) !== 'string') return phone_number;
        const str = (phone_number as string).replace(/[^\d]/g, '').padEnd(10, '_');
        return `(${str.substring(0, 3)}) ${str.substring(3, 6)}-${str.substring(6)}`;
    }

    static format_phone_number_ahead(phone_number: any) {
        if ((typeof phone_number) !== 'string') return phone_number;
        const str = (phone_number as string).replace(/[^\d]/g, '').padEnd(10, '_');
        const truncated_string = str.substring(0, 10);
        return `(${truncated_string.substring(0, 3)}) ${truncated_string.substring(3, 6)}-${truncated_string.substring(6)}`;
    }

    static format_to_numbers_only(input: string) {
        return input.replace(/[^\d]/g, '');
    }

    private static is_numeric(str: string) {
        return !isNaN(Number(str)) && isFinite(Number(str));
    }

    static format_html_to_string(html: string) {
        const regex = /<[^>]*class\s*=\s*['"]([^'"]*?)['"][^>]*>(.*?)<\/[^>]*>/g;
        const output = html.replace(regex, '');
        return output.replace(/<[^>]*>/g, '');
    }

    static decode_html_entities(text: string) {
        const textArea = document.createElement('textarea');
        textArea.innerHTML = text;
        return textArea.value;
    }
}
